import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/age-calculator',
  component: () => import('../../routes/AgeCalculator.svelte'),
  card: {
    id: 'age-calculator',
    title: 'Age Calculator',
    description: 'Calculate your exact age in years, months, days, and discover fun facts about your birth date.',
    icon: 'cake',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/age-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Age Calculator – Exact Age in Years, Months, Days',
    description: 'Free age calculator that calculates your exact age in years, months, days, hours, and minutes. Also shows days until your next birthday and milestone ages you have reached.',
  },
};

export default meta;
